<i18n src='../common_locales.yaml'></i18n>

<i18n>
en:
  order_confirmation: "Order Confirmation"
  personal_details: "Personal details"
  delivery_details: "Delivery details"
  delivery_address: "Delivery address"
  delivery_date: "Delivery date"
  delivery_time: "Delivery time"
  delivery_notes: "Delivery notes"
  order_details: "Order details"
  subtotal: "Subtotal"
  delivery: "Delivery"
  tax: "Tax"
  total: "Total"
  phone_number: "Phone number"
  confirm_order: "Place Order"
  cancel: "Cancel"
  pickup_details: "Pickup details"
  restaurant_name: "Restaurant name"
  pickup_date: "Pickup date"
  pickup_time: "Pickup time"
  pickup_notes: "Pickup notes"
  payment_details: "Payment details"
  payment_method: "Payment method"
  bank_transfer: "Bank transfer"
  cash: "Cash on pickup/delivery"
  thank_you_for_order: "Thank you for your order"
  order_number_is: "Order number is"
  will_receive_email_confirmation: "You will receive an email confirmation shortly at"
  thank_you: "Thank you"
  done: "Done"

ja:
  order_confirmation: "注文の確認"
  personal_details: "個人情報"
  delivery_details: "配達の詳細"
  delivery_address: "配達先"
  delivery_date: "配送日"
  delivery_time: "納期"
  delivery_notes: "配達メモ"
  order_details: "注文詳細"
  subtotal: "小計"
  delivery: "配達"
  tax: "税金"
  total: "合計"
  phone_number: "電話番号"
  confirm_order: "注文を確認する"
  cancel: "キャンセル"
  pickup_details: "ピックアップの詳細"
  restaurant_name: "レストラン名"
  pickup_date: "受取日"
  pickup_time: "お迎えの時間"
  pickup_notes: "ピックアップノート"
  payment_details: "支払い詳細"
  payment_method: "支払い方法"
  bank_transfer: "銀行振込"
  cash: "現金"
  thank_you_for_order: "注文いただきありがとうございます"
  order_number_is: "注文番号は"
  will_receive_email_confirmation: "まもなく確認のメールが届きます"
  thank_you: "ありがとうございました"
  done: "完了"

</i18n>

<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal
      .modal-dialog(role="document")

        .modal-content(v-if="showOrderSuccess")
          .modal-header
            h1 {{ $t('thank_you_for_order') }}
          .modal-body
            .text-center
              img(src="../assets/checkout_checkmark.png")
            h5.mt-3 {{ $t('order_number_is') }}: {{ referenceId }}
            p {{ $t('will_receive_email_confirmation') }} {{ recipientEmail }}. {{ $t('thank_you') }}
          .modal-footer
            button.btn.btn-primary(@click="clickDoneButton") {{ $t('done') }}

        .modal-content(v-else)
          .modal-header
            h1 {{ $t('order_confirmation') }}
          .modal-body
            h5 {{ $t('personal_details') }}
            .card
              .card-body
                div.row-sub-amount {{ $t('name') }}
                  span.text-sub-amount {{ orderDetail.recipient_name }}
                div.row-sub-amount {{ $t('email') }}
                  span.text-sub-amount {{ orderDetail.recipient_email }}
                div.row-sub-amount {{ $t('phone_number') }}
                  span.text-sub-amount {{ orderDetail.recipient_phone }}

            h5.mt-4(v-if="orderDetail.type.indexOf('_delivery') !== -1") {{ $t('delivery_details') }}
            h5.mt-4(v-else) {{ $t('pickup_details') }}
            .card(v-if="orderDetail.type.indexOf('_delivery') !== -1")
              .card-body
                div.row-sub-amount {{ $t('delivery_address') }}
                  span.text-sub-amount {{ orderDetail.recipient_address }}
                div.row-sub-amount {{ $t('delivery_date') }}
                  span.text-sub-amount {{ orderDetail.delivery_date ? orderDetail.delivery_date.substring(0, 10) : 'Unspecified' }}
                div.row-sub-amount {{ $t('delivery_time') }}
                  span.text-sub-amount {{ orderDetail.delivery_hours ? orderDetail.delivery_hours.name_en || orderDetail.delivery_hours : 'Unspecified' }}
                div.row-sub-amount {{ $t('delivery_notes') }}
                  span.text-sub-amount {{ orderDetail.notes }}
            .card(v-else)
              .card-body
                div.row-sub-amount {{ $t('restaurant_name') }}
                  span.text-sub-amount {{ cartRestaurant.name_en }}
                div.row-sub-amount {{ $t('pickup_date') }}
                  span.text-sub-amount {{ orderDetail.pickup_date.substring(0, 10) }}
                div.row-sub-amount {{ $t('pickup_time') }}
                  span.text-sub-amount {{ orderDetail.pickup_hours }}
                div.row-sub-amount {{ $t('pickup_notes') }}
                  span.text-sub-amount {{ orderDetail.notes }}

            h5.mt-4 {{ $t('payment_details') }}
            .card
              .card-body
                div.row-sub-amount {{ $t('payment_method') }}
                  span.text-sub-amount(v-if="orderDetail.payment_type == 'bank_transfer'") {{ $t(orderDetail.payment_type)}} ({{cartRestaurant.bank_account['name_' + $i18n.locale]}})
                  span.text-sub-amount(v-else) {{ $t(orderDetail.payment_type)}}

            h5.mt-4 {{ $t('order_details') }}
            .card
              .card-body
                div(v-for="item in cartItems")
                  p {{ item.quantity }} x {{ getLocaleProductName(item.product) }}
                    span.product-price ¥ {{ item.product.price * item.quantity }}

                .total-amount
                  div.row-sub-amount {{ $t('subtotal') }}
                    span.text-sub-amount ¥ {{ orderDetail.sub_total_price }}
                  div.row-sub-amount(v-if="orderDetail.type.indexOf('_delivery') !== -1") {{ $t('delivery') }}
                    span.text-sub-amount ¥ {{ orderDetail.delivery_fee }}
                  div.row-sub-amount {{ $t('tax') }}
                    span.text-sub-amount ¥ {{ orderDetail.tax }}
                  div.row-total-amount {{ $t('total') }}
                    span.text-total-amount ¥ {{ orderDetail.total_price }}

          .modal-footer
            button.btn.btn-secondary(@click="clickCancelButton") {{ $t('cancel') }}
            button.btn.btn-primary(@click="clickConfirmButton" v-bind:class="{ 'is-loading': submitLoading }") {{ $t('confirm_order') }}
</template>

<script>
import api from '../api'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['orderDetail', 'cartItems', 'cartRestaurant'],
  data () {
    return {
      showOrderSuccess: false,
      referenceId: '',
      recipientEmail: this.orderDetail.recipient_email,
      submitLoading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  created () {
  },
  methods: {
    ...mapActions([
      'clearCart'
    ]),
    clickConfirmButton () {
      this.submitFinalOrder()
    },
    clickCancelButton () {
      this.$modal.close()
    },
    clickDoneButton () {
      this.$modal.close()
      this.$router.push(`/orders/${this.referenceId}`)
    },
    showSuccessView () {
      this.showOrderSuccess = true
    },
    submitFinalOrder () {
      this.submitLoading = true
      api.post('/order/', this.orderDetail)
        .then(response => {
          // Save phone number
          if (!this.user.profile.phone && this.user.profile.email === this.orderDetail.recipient_email) {
            let data = { phone: this.orderDetail.recipient_phone }
            api.post('/customers/edit/', data)
            .then(response => {
            })
          }

          // Save billing info
          if (!this.user.profile.billing && this.orderDetail.billing_info) {
            let data = { billing_info: JSON.stringify(this.orderDetail.billing_info) }

            api.post('/customers/edit/', data)
            .then(response => {
            })
          }

          this.clearCart()
          this.referenceId = response.data.reference_id
          this.showSuccessView()
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.data)
          } else {
            console.log('Error', error.message)
          }
          this.$toasted.error('Your order can\'t be processed. Please try again.')
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    getLocaleProductName (product) {
      return product['name_' + this.$i18n.locale]
    }
  }
}
</script>


<style lang="scss">
.cart-card {
  .table {
    margin-bottom: 0;
  }
}
.btn-submit-order {
  padding-left: 4rem;
  padding-right: 4rem;
}
.product-price {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/CheckoutConfirmationModal.vue